/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React, { useState } from 'react';
import { useTheme } from '../../../providers/theme';

import {
  HeroSection,
  EditProfileModal,
  UpdateModal,
  VerificationModal,
  TimelineDetailModal,
} from '../components';

import {
  useSMupdateProfile,
  useSMUpdateKyc,
  useSMSendOTP,
  useSMVerifyOTP,
  useSMMyAccountPage,
} from '../machines';

import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';

import { vappContainer } from '@/application';
import { MyProfilePageService } from '@pages/MyProfilePage/services';

const getSrv = () => {
  return vappContainer.get<MyProfilePageService>(
    MyProfilePageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [showOtpModal, setShowOTPModal] = useState(false);
  const [cardModal, setCardModal] = useState<boolean>(false);
  const [cardId, setCardId] = useState<string>('');
  const srv = getSrv();
  const staticPageContentConfig = srv?.agent?.getStaticContentSync();

  const { updateProfileMachine, updateProfileSend, updateProfileState } =
    useSMupdateProfile({});
  const { updateKycMachine, updateKycSend, updateKycState } = useSMUpdateKyc(
    {}
  );
  const theme = useTheme();
  const { myaccountPageMachine, myaccountPageState, myaccountPageSend } =
    useSMMyAccountPage({});

  const { sendOTPMachine, sendOTPSend } = useSMSendOTP({});
  const { verifyOTPMachine, verifyOTPSend, verifyOTPState } = useSMVerifyOTP(
    {}
  );

  const onButtonPress = (key: string) => {
    if (key === 'edit') {
      if (!showModal) {
        setShowModal(true);
      }
    }
    if (key === 'updateKyc') {
      if (!updateModal) {
        setUpdateModal(true);
      }
    }
    if (key === 'verifyPhone') {
      sendOTPSend('START', {
        payload: {
          email: myaccountPageState?.event?.data?.value?.email,
          sendOn: 'sms',
        },
      });
      if (!showOtpModal) {
        setShowOTPModal(true);
      }
    }
  };

  const resendOTP = () => {
    sendOTPSend('RE_SEND', {
      payload: {
        email: myaccountPageState?.event?.data?.value?.email,
        sendOn: 'sms',
      },
    });
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
    if (updateModal) {
      setUpdateModal(false);
    }
    if (showOtpModal) {
      setShowOTPModal(false);
    }
  };

  const onCardClick = (id: string) => {
    console.log(`card clicked`, id);
    let _cardDetail = srv?.agent?.getFormatTimelineDetailSync({
      ...myaccountPageState?.event?.data?.value?.timelineData,
      cardId: id,
    });
    console.log('card detail', _cardDetail);

    if (
      Array.isArray(_cardDetail?.data?.data) &&
      _cardDetail?.data?.data?.length > 0
    ) {
      if (!cardModal) {
        setCardModal(true);
      }
      setCardId(id);
    }
  };

  const onCardClose = (id: string) => {
    if (cardModal) {
      setCardModal(!cardModal);
    }
  };

  const onRefreshClick = () => {
    myaccountPageSend('TRIGGER_REFRESH', {});
  };

  const onUpdateProfileSubmit = (data: any) => {
    console.log(
      `profile data`,
      myaccountPageState?.event?.data?.value?.phoneVerified
    );
    let phoneVerified = myaccountPageState?.event?.data?.value?.phoneVerified;

    if (showModal) {
      setShowModal(false);
    }
    if (phoneVerified) {
      updateProfileSend('START', {
        payload: {
          firstName: data?.firstName,
          lastName: data?.lastName,
          image: data?.image?.base64,
          address: {
            addressLine1: data?.streetAddress,
            city: data?.city,
            country: data?.country,
          },
          occupation: data?.occupation,
        },
      });
    } else {
      updateProfileSend('START', {
        payload: {
          firstName: data?.firstName,
          lastName: data?.lastName,
          primaryContactNo: data?.primaryContactNo,
          image: data?.image?.base64,
          address: {
            addressLine1: data?.streetAddress,
            city: data?.city,
            country: data?.country,
          },
          occupation: data?.occupation,
        },
      });
    }
  };

  const onUpdateKYCDoc = (data: any) => {
    console.log(`update KYC`, data);
    if (updateModal) {
      setUpdateModal(false);
    }

    updateKycSend('START', {
      payload: data,
    });
  };

  const onOTPSubmit = (data: any) => {
    if (showOtpModal) {
      setShowOTPModal(false);
    }
    verifyOTPSend('START', {
      payload: {
        otp: data?.otp,
      },
    });
  };

  const _renderModal = () => {
    console.log(
      `fields`,
      myaccountPageState?.event?.data?.value?.profileForms?.fields
    );
    if (showModal) {
      return (
        <TweetyModal
          show={true}
          size={'md'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={onUpdateProfileSubmit}
          onHide={() => setShowModal(false)}
          title={'Update Profile'}
          tweetyWidgetProps={{
            fields:
              myaccountPageState?.event?.data?.value?.profileForms?.fields,
            layout: staticPageContentConfig?.profileForm?.layout,
            validatorConfig:
              staticPageContentConfig?.profileForm?.validatorConfig,
            initialData: {
              ...(myaccountPageState?.event?.data?.value?.initialData || {}),
            },
          }}
        />
      );
    }
    if (updateModal) {
      console.log(`update kyc:`, myaccountPageState?.event?.data?.value);
      return (
        <TweetyModal
          show={true}
          size={'md'}
          scrollable={false}
          onHide={() => setUpdateModal(false)}
          backdrop={'static'}
          submitButtonTitle={'Update KYC Documents'}
          onSubmit={onUpdateKYCDoc}
          title={'Update KYC'}
          tweetyWidgetProps={{
            fields: [
              ...myaccountPageState?.event?.data?.value?.kycForms?.fields,
            ],
            layout: [
              ...myaccountPageState?.event?.data?.value?.kycForms?.layout,
            ],
            validatorConfig:
              myaccountPageState?.event?.data?.value?.kycForms?.validatorConfig,
            initialData: {
              ...(myaccountPageState?.event?.data?.value?.kycForms
                ?.initialData || {}),
            },
          }}
        />
      );
    }
    if (showOtpModal) {
      return (
        <VerificationModal
          showModal={true}
          onOTPSubmit={onOTPSubmit}
          resendOtpClick={resendOTP}
          phoneNumber={myaccountPageState?.event?.data?.value?.phoneNumber}
          onDeny={onModalClose}
        />
      );
    }
    if (cardModal) {
      let _temp = srv?.formatTimeLineDetail({
        ...myaccountPageState?.event?.data?.value?.timelineData,
        cardId,
      });
      console.log(`_temp data`, _temp);
      return (
        <TimelineDetailModal
          showModal={cardModal}
          modalTitle={_temp?.title}
          data={_temp?.data}
          onDeny={onCardClose}
        />
      );
    }
  };

  const _renderPage = () => {
    if (verifyOTPState?.matches('VERIFY_OTP')) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.verifyOTP || {})} />
      );
    }
    if (
      updateProfileState?.matches('UPDATE_PROFILE') ||
      updateKycState?.matches('UPDATE_KYC')
    ) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.GetPageLoading || {})}
        />
      );
    }
    if (staticPageContentConfig?.myProfile?.email) {
      console.log(
        `kyc state`,
        myaccountPageState?.event?.data?.value?.kycSubmitted
      );
      return (
        <>
          <HeroSection
            {...(staticPageContentConfig?.myProfile || {})}
            {...(myaccountPageState?.event?.data?.value || {})}
            onHeroButtonClick={onButtonPress}
            carouselItems={
              myaccountPageState?.event?.data?.value?.carouselItems ?? []
            }
            buttons={myaccountPageState?.event?.data?.value?.buttons ?? []}
            timelineCardClick={onCardClick}
          />
        </>
      );
    }
    if (myaccountPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          <HeroSection
            {...(myaccountPageState?.event?.data?.value || {})}
            onHeroButtonClick={onButtonPress}
            timelineCardClick={onCardClick}
          />
        </>
      );
    }
    if (myaccountPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.GetPageLoading || {})}
        />
      );
    }
    return null;
  };

  const _renderNotifications = () => {
    if (verifyOTPState?.matches('VERIFY_OTP_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.verifyOTP || {})}
          onAcknowledgement={onRefreshClick}
          onDeny={onRefreshClick}
        />
      );
    }
    if (updateProfileState?.matches('UPDATE_PROFILE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.updateProfileSuccess ||
            {})}
          onAcknowledgement={onRefreshClick}
          onDeny={onRefreshClick}
        />
      );
    }
    if (updateKycState?.matches('UPDATE_KYC_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.updateProfileSuccess ||
            {})}
          onAcknowledgement={() => window.location.reload()}
          onDeny={onRefreshClick}
        />
      );
    }
    return null;
  };

  const _renderErrorNotification = () => {
    if (verifyOTPState?.matches('VERIFY_OTP_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.verifyOTP || {})}
          onAcknowledgement={onRefreshClick}
          onDeny={onRefreshClick}
        />
      );
    }
    if (myaccountPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.myAccount || {})}
          onAcknowledgement={onRefreshClick}
          onDeny={onRefreshClick}
        />
      );
    }
    if (updateKycState?.matches('UPDATE_KYC_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.myAccount || {})}
          onAcknowledgement={onRefreshClick}
          onDeny={onRefreshClick}
        />
      );
    }
    if (updateProfileState?.matches('UPDATE_PROFILE_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.updateProfile || {})}
          onAcknowledgement={onRefreshClick}
          onDeny={onRefreshClick}
        />
      );
    }
  };
  return (
    <>
      {_renderPage()}
      {_renderModal()}
      {_renderErrorNotification()}
      {_renderNotifications()}
    </>
  );
};
